/* The spinner and the button carry their own Emotion sizes, injected unlayered, which a Tailwind utility cannot override. */
.footer {
  display: flex;
  align-items: center;
  height: 40px;
  font-size: 1rem;
  line-height: 1.625rem;
}

.footer svg {
  margin-left: 1rem;
  width: 1rem;
  height: 1rem;
}

.footer button {
  width: calc(100% - 26px);
}
